var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterfollowus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 71,
    viewBox: "0 0 84 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20532 35.7104H74.0077",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20532 61.5269H51.1184",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8915 61.5269H61.6168",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7395 61.5269H72.4649",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7809 61.5269H82.7947",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0693 35.7104H82.7947",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    width: 82,
    height: 7,
    rx: 3.5,
    fill: "#555571",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41C58.3137 41 61 38.3137 61 35C61 31.6863 58.3137 29 55 29C51.6863 29 49 31.6863 49 35C49 38.3137 51.6863 41 55 41Z",
    fill: "#DD44B9",
    stroke: "#191928",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17C20.3137 17 23 14.3137 23 11C23 7.68629 20.3137 5 17 5C13.6863 5 11 7.68629 11 11C11 14.3137 13.6863 17 17 17Z",
    fill: "#DD44B9",
    stroke: "#191928",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32 67C35.3137 67 38 64.3137 38 61C38 57.6863 35.3137 55 32 55C28.6863 55 26 57.6863 26 61C26 64.3137 28.6863 67 32 67Z",
    fill: "#DD44B9",
    stroke: "#191928",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterfollowus);
export default __webpack_public_path__ + "static/media/footerfollowus.9dc1f523012c81903141be1227ea7429.svg";
export { ForwardRef as ReactComponent };